module.exports = __webpack_public_path__ + "img/GALLERY-ERTIGA-BOOSTER-GREEN-3.17546680.jpg";